module.exports = __webpack_public_path__ + "media/packs/images/flags/KW-56720665c8a6df02825e6f50d20b58de.svg";